/* eslint-disable camelcase */
import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import ShStarRating from '@/components/Helpers/ShStarRating';
import ShTextWrapper from '@/components/Helpers/ShTextWrapper';
import ShRecordPlayer from '@/components/Helpers/ShRecordPlayer';
import ConnectionChangeStatus from '@/components/Connections/ConnectionDetailsAndNotes/ConnectionChangeStatus';

import customerDefaultAvatar from './defaultAvatar';

// @vue/component
export default {
  name: 'ConnectionDetails',

  components: {
    ShUserAvatar,
    ShStarRating,
    ShTextWrapper,
    ShRecordPlayer,
    ConnectionChangeStatus,
  },

  props: {
    connection: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      defaultNotifyStatus: {
        fa_icon: 'fa-refresh',
        color: '#4A4C54',
        description: '---',
      },
      defaultBillingEffect: {
        title: 'Brak',
        value: '',
        color: '#4A4C54',
      },
      customerDefaultAvatar,
    };
  },

  computed: {
    notifyStatus() {
      // eslint-disable-next-line camelcase
      const { notify_status } = this.connection;
      return (this.$store.getters['connections/connectionsSettings'].notifyStatuses
        // eslint-disable-next-line camelcase
        .find(notify => notify.status_name === notify_status)) || this.defaultNotifyStatus;
    },
    billingEffect() {
      const { effect } = this.connection;
      return (this.$store.getters['app/dictionaryBillingEffect'].find(item => item.key === effect)) || this.defaultBillingEffect;
    },
    callbackMessage() {
      return this.$store.getters['callbackMessages/details'].message;
    },
    isLoadingCallbackMessage() {
      return this.$store.getters['app/pendingStoreActions'].includes(['callbackMessages/get']);
    },
    shouldHaveFeedbackMessage() {
      return ['UNSUCCESSFUL_FEEDBACK', 'WAITNG_FOR_CALLBACK_MANUALLY', 'FEEDBACK'].includes(this.connection.notify_status);
    },
    isLoadingCallRecord() {
      return this.$store.getters['app/pendingStoreActions'].includes(['callRecordings/get']);
    },
    callRecord() {
      return this.$store.getters['callRecordings/details'].record;
    },
    shouldGetAndShowCallRecording() {
      return this.connection.is_recorded && this.connection.records_is_available && (this.connection.effect === 'connected' && this.connection.call_end);
    },
  },

  created() {
    if (this.shouldGetAndShowCallRecording) {
      const callGuid = this.connection.callque_guid;
      this.$store.dispatch('callRecordings/get', callGuid);
    }

    if (['UNSUCCESSFUL_FEEDBACK', 'WAITNG_FOR_CALLBACK_MANUALLY', 'FEEDBACK'].includes(this.connection.notify_status)) {
      const sessionId = this.connection.session_id;
      this.$store.dispatch('callbackMessages/get', sessionId);
    }
  },

  beforeDestroy() {
    const { recordPlayer } = this.$refs;
    if (recordPlayer) {
      recordPlayer.playerStopPlay();
    }
  },

  methods: {
    __prepareRequestTimestampForFileName(requestTimestamp) {
      return ((requestTimestamp.split('+')[0]).replaceAll(' ', '_')).replaceAll(':', '-');
    },
    handleDownloadRecord() {
      const { calling_number, reached_number, request_timestamp, domain } = this.connection;
      const fileName = `${calling_number}_${reached_number}_${this.__prepareRequestTimestampForFileName(request_timestamp)}_${domain}`;
      this.forceFileDownload(this.callRecord, fileName);
    },
    forceFileDownload(response, fileName) {
      const element = document.createElement('a');
      element.setAttribute('href', response);
      element.setAttribute('download', `${fileName}.mp3`);
      if (document.createEvent) {
        const event = document.createEvent('MouseEvents');
        event.initEvent('click', true, true);
        element.dispatchEvent(event);
      } else {
        element.click();
      }
    },
  },
};
